import React, {
  useEffect,
  useContext,
  useRef,
  useState,
  useMemo,
  memo,
} from "react";
import { AppContext } from "../context";
import * as tf from "@tensorflow/tfjs";
import {
  PartDetector,
  setBackendExternally,
} from "../partdetection_new/PartDetector";
import {
  runCarPartDetection,
  preprocessVideo,
  // getLastVanInfo, // DEBUG (commented out)
} from "../partdetection_new/NewPartDetector";
import { Guidance } from "../guidance_new/GuidanceMain";
import drawArc from "../utils_new/DrawArc";
import {
  startCarVideoRecording,
  stopCarVideoRecordingAndUpload,
} from "../utils_new/carVideoRecorder";
import {
  getSharedInferenceWorker,
  makeLowLightFrameShim,
} from "../utils_new/inferenceWorkerClient";
import carsmall from "../img/carsmall.png";
import instImg from "../img/instImg.svg";
import initRedImg from "../img/coverage_red.png";
import nearFarArrow from "../img/zizo_arrow.gif";
import Rotate from "./Rotate";
import {
  addImageToList,
  sendCoveredArea,
  setLog,
  actualRegion,
  userLogs,
  patLogs,
  getModel,
  resumeFlowFinalSubmitHandler,
  setImgCOunt,
  getConstraint,
  getAspectRatioClientList,
  getLumaBlurScore,
  getWebpImageFormat,
  getImgQualityFactor,
  setAllSideCoveredVideo,
  getRedirectVideoToImgFlag,
  setPortoModuleComplete,
  filterPortoModuleList
} from "../context/utils";

import * as constants from "../utils_new/Constants";
import { goodFrame } from "../guidance_new/Stencil";

import Front from "./Stencils/car/Front";
import Front_Isometric_Left from "./Stencils/car/Front-Isometric-Left";
import Front_Isometric_Right from "./Stencils/car/Front-Isometric-Right";
import Side_Left from "./Stencils/car/Side-Left";
import Side_Right from "./Stencils/car/Side-Right";
import Rear from "./Stencils/car/Rear";
import Rear_Isometric_Right from "./Stencils/car/Rear-Isometric-Right";
import Rear_Isometric_Left from "./Stencils/car/Rear-Isometric-Left";
import StencilInst from "./Stencils/stenciInst.svg";
import HoldSvg from "./Stencils/hold.svg";
import { get } from "underscore";

const MemoizedStencil = memo(({ Component, color }) => {
  return <Component strokeColor={color} />;
});

const tinyCanvas = document.createElement("canvas");
tinyCanvas.width = 64;
tinyCanvas.height = 64;
const tinyCtx = tinyCanvas.getContext("2d", { willReadFrequently: true });

let regionStencil = {
  Front: Front,
  "Front-Isometric-Left": Front_Isometric_Left,
  "Side-Left": Side_Left,
  "Rear-Isometric-Left": Rear_Isometric_Left,
  Rear: Rear,
  "Rear-Isometric-Right": Rear_Isometric_Right,
  "Side-Right": Side_Right,
  "Front-Isometric-Right": Front_Isometric_Right,
};

const vinRegion = [
  "Front",
  "Front-Isometric-Left",
  "Side-Left",
  "Rear-Isometric-Left",
  "Rear",
  "Rear-Isometric-Right",
  "Side-Right",
  "Front-Isometric-Right",
  "Front",
];

let regionIcon = {
  Front:
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Front.svg",
  "Front-Isometric-Right":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Front+right.svg",
  "Side-Right":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Right.svg",
  "Rear-Isometric-Right":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Back+right.svg",
  Rear: "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Back.svg",
  "Rear-Isometric-Left":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Back+left.svg",
  "Side-Left":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Left.svg",
  "Front-Isometric-Left":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Front+left.svg",
};

let stencilImageDivRunOnce = true;
let missedstep = false;
let logbugs = true;
let regionsAndAnglesMap = {};
for (let val of Object.values(constants.REGIONS))
  regionsAndAnglesMap[val] = new Set();
let allActualRegionDataLog = {};
let allActualRegionDataLogsCheck = {};
let finalRegionsMap = {};
let captured = 0;
let allActualRegionData = {};
let actualGuidanceRegion;
let seconds = 0;
let minutes = 0;
let WholeLightLumaData = "";
let data = {};
let track = null;
let angleDetectedGyro = [];
let currentUploadedPartCount = null;
let detectMlCheck = true;
// Cap on the detect-loop iteration rate (same recipe as NewVideo): with
// inference off the main thread the loop is no longer throttled by
// executeAsync, and every iteration pays captureImgFrame on the main thread.
// Override per client via config["video-page"]["detectIntervalMs"].
let lastDetectIterationTs = 0;
let minDetectIntervalMs = 250;
let imgValue = 0;
let afterFrameimgValue = 0;
let stopRecordingML = false;
let allowImgURLmain = {};
let regionWiseData = {};
let allFrameUpload = false;
let checkOnceRegion = true;
let hold = true;
let hold2 = true;
let currentStencil = "";
let showCoveredRegion = {};
let showCoveredRegioncheck = {};
let staticRegion = "";
let frameUploadStencil = false;
let captureStencilDialGrren = [];
let captureStencilDialRed = [];
let imageFrameInterval;
let frameInterval;
let stencilCheckInterval;
let InstructionClear;
let checkLumaValue = true;
let startRefCheck;
let checkImageList = [];
let checkImageList2 = [];
let checkImageList3 = [];
let lastSharpCheck = 0;
let previousAngle = [
  0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170,
  180, 190, 200, 210, 220, 230, 240, 250, 260, 270, 280, 290, 300, 310, 320,
  330, 340, 350, 360,
];
let detectionFuncTime = 3;
let lastLayoutRegion = null;
let lastLayoutWidth = 0;
let lastLayoutHeight = 0;
let startTimeModel = 0;
let consoleOnceModel = true;
let getTimeonce = true;
let detectOnce = true;
// let coldStartOnce = true; // DEBUG (commented out)
// NEW VARIABLES TO HOLD STATIC LOGS
let coldStartText = "";
let regionDetectedText = "";
let currentVisibleStencilEl = null;

const StencilVideo = () => {
  const {
    skipStencil,
    setSkipStencil,
    alignStencil,
    setalignStencil,
    capturedStencil,
    setcapturedStencil,
    stepCovered,
    setStepCovered,
    setScreen,
    currentBlock,
    condition,
    setCondition,
    config,
    token,
    mandatory,
    setMandatory,
    inspectionId,
    setStopPing,
    setCurrentPage,
    stopPing,
    restrictUserIfallNotGreen,
    setRestrictUserIfallNotGreen,
    clientId,
    caseId,
    isIOS,
    setFallbackCondition,
    setFallbackSubCondition,
    setFallbackMandatory,
    setFallbackSubMandatory,
    setFallbackBlockId,
  } = useContext(AppContext);

  let frameResolution =
    Object.keys(config).includes("int8Model") && config["int8Model"]
      ? 320
      : 128;

  const [mainRegion, setmainRegion] = useState("");
  const [lumacheck, setLumaCheck] = useState(false);
  const [holdSkip, setHoldSkip] = useState(true);
  const [errorType, setErrorType] = useState(false);

  const stateTrackers = useRef({
    activeStencil: null,
    stencilColor: "#fff",
    isStencilVisible: false,
  });

  const timerRef = useRef();
  const videoRef = useRef();
  const canvasRef = useRef();
  const cardRef = useRef();
  const screen3 = useRef();
  const stencilImageDiv = useRef();
  const loaderGuidanceText = useRef();
  const imgRef = useRef();
  const startRef = useRef();
  const warnRef = useRef();
  const canvas1 = useRef();
  const chooseRegionStencil = useRef();
  const holdImage = useRef();
  const partDetector = new PartDetector();
  const displayText = useRef();
  const detectionBox = useRef();
  // const inferenceTimeRef = useRef(); // DEBUG (commented out)
  // const modelInitTimeRef = useRef(); // DEBUG (commented out)
  // const coldStartTimeRef = useRef(); // DEBUG (commented out)
  // const detectionLogRef = useRef(); // DEBUG (commented out)
  // const vanFlagRef = useRef(); // DEBUG (commented out)
  // const partData = useRef();
  // const partDataValue = useRef();
  // const partDataValueList = useRef();
  const leftNearArrow = useRef();
  const rightNearArrow = useRef();
  const leftFarArrow = useRef();
  const rightFarArrow = useRef();
  const leftArrowVin = useRef();
  const rightArrowVin = useRef();
  const downArrow = useRef();
  const upArrow = useRef();
  const skipDiv = useRef();
  const resizeCanvasRef = useRef(null);
  const resizeCtxRef = useRef(null);
  const guidance = new Guidance(
    config["video-page"]["guidanceMessages"],
    clientId,
    config,
  );
  const confirmSkipDiv = useRef();
  const showResult = useRef();
  const instImage = useRef();
  const skipDivFallback = useRef();

  data = {
    text: config["video-page"]["dataText"],
    feedbacks: [],
    regionsCovered: guidance.regionsCoveredMap,
    angle: 0,
    region: "",
    nudges: { partToPoint: "", Nudge: "" },
  };
  showCoveredRegion = guidance.regionsCoveredMap;

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text))
      return config["language"][text];
    else return text;
  };

  const ua = navigator.userAgent.toLowerCase();
  const isIos = !!/iPhone|iPad|iPod/i.test(ua);
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  let webCamPromise = null;
  let model = null;
  let active = true;
  let images = [];
  let endTimer = 0;
  let modalFlag = false;
  let startTimer = null;
  let allRegionsCovered = false;
  let allGreen = false;
  let detections = [];

  const isLandscape = () => window.innerWidth > window.innerHeight * 1.2;
  if (logbugs) {
    patLogs("Entered to Video module", inspectionId);
    userLogs({ position: 8, last_page: "stencil video module", inspectionId });
  }
  logbugs = false;

  const sendLogData = async (data) => userLogs(data);
  const getAllFrameUpload = () => allFrameUpload;

  const uploadImg = (imgURL) => {
    imgValue = imgValue + 1;
    let region = Object.keys(config["video-page"]).includes("clientRegion")
      ? config["video-page"]["clientRegion"]
      : "eu-central-1";

    addImageToList({
      name: `${captured}.jpg`,
      imgData: imgURL,
      tag: data.region,
      angle: data.angle,
      web_region: data.region,
      env: 1,
      region: region,
      videoData: "",
      dialStatus: finalRegionsMap,
    });
    captured++;
  };

  const uploadImgInterim = (imgURL) => {
    imgValue = imgValue + 1;
    let region = Object.keys(config["video-page"]).includes("clientRegion")
      ? config["video-page"]["clientRegion"]
      : "eu-central-1";
    addImageToList({
      name: `${captured}.jpg`,
      imgData: imgURL,
      tag: `${data.region}_interim`,
      angle: data.angle,
      web_region: data.region,
      region: region,
      env: 1,
      videoData: "",
      dialStatus: finalRegionsMap,
    });
    captured++;
  };

  const setMandatoryCondition = async () => {
    let tempCondition = condition,
      tempMandatory = mandatory,
      tempSubMandatoryCondtion = subMandatory,
      tempSubCondtion = subCondition;

    //console.log("mandatory in kiwi :: ", tempCondition, tempMandatory, tempSubMandatoryCondtion, tempSubCondtion)
    tempCondition[IMG360CONFIG["id"]] = "pending";
    setFallbackCondition(tempCondition);

    let temp2Condition = condition, temp2Mandatory = mandatory;
    if (Object.keys(temp2Condition).includes(IMG360CONFIG["id"])) delete temp2Condition[IMG360CONFIG["id"]];
    setCondition(temp2Condition);

    tempMandatory[IMG360CONFIG["id"]] = "pending";
    setFallbackMandatory(tempMandatory);

    if (Object.keys(temp2Mandatory).includes(IMG360CONFIG["id"])) delete temp2Mandatory[IMG360CONFIG["id"]];
    setMandatory(temp2Mandatory);

    tempSubMandatoryCondtion[IMG360CONFIG["id"]] = {};
    tempSubCondtion[IMG360CONFIG["id"]] = {};
    IMG360CONFIG.values.map((item2) => {
      tempSubMandatoryCondtion[IMG360CONFIG["id"]][item2.name] = "pending";
      tempSubCondtion[IMG360CONFIG["id"]][item2.name] = "pending";
    });

    setFallbackSubCondition(tempSubCondtion);
    setFallbackSubMandatory(tempSubMandatoryCondtion);
    setFallbackBlockId(currentBlock["id"])
    //console.log("current block seet ::  ", currentBlock["id"], condition, mandatory, tempCondition, tempMandatory, tempSubMandatoryCondtion, tempSubCondtion)
  };

  const captureImgFrame = (byPassBlack) => {
    const cnv = canvasRef.current;
    const vw = videoRef.current;

    if (!cnv || !vw || vw.videoWidth === 0 || vw.videoHeight === 0) {
      return false;
    }

    cnv.width = vw.videoWidth;
    cnv.height = vw.videoHeight;

    const ctx = cnv.getContext("2d", { willReadFrequently: true });
    if (!ctx) return false;

    ctx.drawImage(vw, 0, 0, cnv.width, cnv.height);

    return cnv.toDataURL("image/jpeg", 0.9);
  };
  const setupVideoWithStencilBox = (currentRegion) => {
    const videoEl = videoRef.current;
    if (!videoEl || !stencilImageDiv?.current) return false;

    const containerWidth = window.innerWidth;
    const containerHeight = window.innerHeight;
    const vW = videoEl.videoWidth;
    const vH = videoEl.videoHeight;
    if (!vW || !vH) return false;

    const videoAspect = vW / vH;
    const containerAspect = containerWidth / containerHeight;
    let displayWidth, displayHeight;
    if (videoAspect > containerAspect) {
      displayWidth = containerWidth;
      displayHeight = containerWidth / videoAspect;
    } else {
      displayHeight = containerHeight;
      displayWidth = containerHeight * videoAspect;
    }

    const xOff = (containerWidth - displayWidth) / 2;
    const yOff = (containerHeight - displayHeight) / 2;
    const box = stencilImageDiv.current;
    box.style.left = `${xOff}px`;
    box.style.top = `${yOff}px`;
    box.style.width = `${displayWidth}px`;
    box.style.height = `${displayHeight}px`;
    box.style.display = "flex";
    box.style.alignItems = "flex-end";
    box.style.justifyContent = "center";
    return true;
  };

  const calculateUserPositions = (variable, constant) => {
    const variableIndex = vinRegion.indexOf(variable);
    const constantIndex = vinRegion.indexOf(constant);
    let res;
    if (variableIndex === -1 || constantIndex === -1) {
      res = "undefined";
    } else {
      const totalRegions = vinRegion.length;
      const clockwiseDistance =
        (constantIndex - variableIndex + totalRegions) % totalRegions;
      const counterClockwiseDistance =
        (variableIndex - constantIndex + totalRegions) % totalRegions;
      if (clockwiseDistance === 0 || counterClockwiseDistance === 0)
        res = "same";
      else if (clockwiseDistance < counterClockwiseDistance) res = "left";
      else if (counterClockwiseDistance < clockwiseDistance) res = "right";
      else res = "left";
    }
    return res;
  };

  const updateStencilDOM = (targetStencil, isVisible, color) => {
    if (
      currentVisibleStencilEl &&
      currentVisibleStencilEl.id !== `stencil-${targetStencil}`
    ) {
      currentVisibleStencilEl.style.opacity = "0";
      currentVisibleStencilEl.style.visibility = "hidden";
      currentVisibleStencilEl = null;
    }

    if (isVisible && targetStencil) {
      const el = document.getElementById(`stencil-${targetStencil}`);
      if (el) {
        el.style.opacity = "1";
        el.style.visibility = "visible";
        el.style.setProperty("--stencil-color", color);

        const shapes = el.querySelectorAll("[stroke]");
        for (let i = 0; i < shapes.length; i++) {
          shapes[i].setAttribute("stroke", color);
        }
        currentVisibleStencilEl = el;
      }
    } else if (!isVisible && currentVisibleStencilEl) {
      currentVisibleStencilEl.style.opacity = "0";
      currentVisibleStencilEl.style.visibility = "hidden";
      currentVisibleStencilEl = null;
    }
  };

  const skipButton = () => {
    if (hold2) {
      setSkipStencil((e) => {
        return [...e, currentStencil];
      });
    }
    clearInterval(imageFrameInterval);
    clearTimeout(stencilCheckInterval);
    stencilCheckInterval = null;
    frameUploadStencil = false;

    setcapturedStencil((prevCaptured) => {
      const updated = [...prevCaptured, currentStencil];
      setalignStencil((prevAlign) => {
        const alginAndFilterStencil = prevAlign.filter(
          (item) => !updated.includes(item),
        );
        if (updated.length > 1) {
          setmainRegion(alginAndFilterStencil[0]);
          currentStencil = alginAndFilterStencil[0];
          stateTrackers.current.stencilColor = "#fff";
          updateStencilDOM(alginAndFilterStencil[0], true, "#fff");
        }
        return alginAndFilterStencil;
      });
      if (updated.length === 1) {
        currentStencil = "";
        chooseRegionStencil.current.style.display = "flex";
      }
      if (updated.length > 7) {
        currentStencil = "";
        chooseRegionStencil.current.style.display = "flex";
      }
      return updated;
    });
    skipDiv.current.style.display = "none";
    hold = true;
    hold2 = true;
    stencilImageDivRunOnce = true;
    skipDiv.current.style.display = "none";
    checkLumaValue = true;
  };

  const continueButton = () => {
    hold = true;
    hold2 = true;
    stencilCheckInterval = null;
    skipDiv.current.style.display = "none";
  };

  const getLumaRes = async (img) => {
    let payload = {
      env: 1,
      region: "eu-central-1",
      inspection_id: inspectionId,
      client_id: clientId,
      image:
        getWebpImageFormat() && !isIOS
          ? img.replace(/^data:image\/webp;base64,/, "")
          : img.replace(/^data:image\/jpeg;base64,/, ""),
    };
    let value = await getLumaBlurScore(payload);
    if (
      typeof value === "object" &&
      value !== null &&
      !Array.isArray(value) &&
      Object.keys(value).length > 0 &&
      Array.isArray(value[Object.keys(value)[0]]) &&
      typeof value[Object.keys(value)[0]][1] === "number" &&
      value[Object.keys(value)[0]][1] < 2 &&
      !value[Object.keys(value)[0]][1] === 0
    ) {
      if (
        chooseRegionStencil.current.style.display === "flex" ||
        skipDiv.current.style.display === "flex"
      )
        return;

      setLumaCheck(true);
      hold = false;

      stateTrackers.current.activeStencil = null;
      stateTrackers.current.isStencilVisible = false;
      updateStencilDOM(null, false, "#fff");

      upArrow.current.style.display = "none";
      downArrow.current.style.display = "none";
      leftFarArrow.current.style.display = "none";
      rightFarArrow.current.style.display = "none";
      leftNearArrow.current.style.display = "none";
      rightNearArrow.current.style.display = "none";
      displayText.current.innerHTML = "";
      displayText.current.style.display = "none";
      holdImage.current.style.display = "none";
      skipDiv.current.style.display = "flex";
    }
  };

  const getMaxItem = (arr) => {
    const freq = {};
    for (const item of arr) {
      freq[item] = (freq[item] || 0) + 1;
    }
    let maxItem = null;
    let maxCount = 0;
    for (const item in freq) {
      if (freq[item] > maxCount) {
        maxCount = freq[item];
        maxItem = Number(item);
      }
    }
    return maxItem;
  };

  const drawBoxWithDiv = (topLeft, bottomRight, color) => {
    const screenW = window.innerWidth;
    const screenH = window.innerHeight;
    const videoEl = videoRef.current;
    const videoAspect = (videoEl && videoEl.videoWidth && videoEl.videoHeight)
      ? videoEl.videoWidth / videoEl.videoHeight
      : 16 / 9;
    const screenAspect = screenW / screenH;
    let displayW, displayH, xOff, yOff;
    if (videoAspect > screenAspect) {
      displayW = screenW;
      displayH = screenW / videoAspect;
      xOff = 0;
      yOff = (screenH - displayH) / 2;
    } else {
      displayH = screenH;
      displayW = screenH * videoAspect;
      xOff = (screenW - displayW) / 2;
      yOff = 0;
    }

    const originalTopLeft = [
      xOff + (topLeft[0] / frameResolution) * displayW,
      yOff + (topLeft[1] / frameResolution) * displayH,
    ];

    const originalBottomRight = [
      xOff + (bottomRight[0] / frameResolution) * displayW,
      yOff + (bottomRight[1] / frameResolution) * displayH,
    ];
    detectionBox.current.style.display = "flex";
    const [x1, y1] = originalTopLeft;
    const [x2, y2] = originalBottomRight;

    const width = x2 - x1;
    const height = y2 - y1;

    // Create a new box div
    const box = document.createElement("div");
    box.style.position = "absolute";
    box.style.left = `${x1}px`;
    box.style.top = `${y1}px`;
    box.style.width = `${width}px`;
    box.style.height = `${height}px`;
    box.style.border = `2px solid ${color}`;
    box.style.boxSizing = "border-box";

    // Append to container
    detectionBox.current.appendChild(box);
  };

  const updateStencilValue = (
    currentRegion,
    detections,
    realGyroAngle,
    currentAngle,
  ) => {
    if (
      chooseRegionStencil.current.style.display === "flex" ||
      skipDiv.current.style.display === "flex" ||
      confirmSkipDiv.current.style.display === "flex"
    )
      return;

    if (checkOnceRegion) {
      checkOnceRegion = false;
      currentStencil = currentRegion;
    }

    if (currentRegion && currentStencil) {
      if (checkLumaValue && hold) {
        let imgValue = captureImgFrame(true);
        if (imgValue) {
          checkLumaValue = false;
        }
      }

      if (
        lastLayoutRegion !== currentRegion ||
        lastLayoutWidth !== window.innerWidth ||
        lastLayoutHeight !== window.innerHeight
      ) {
        const ok = setupVideoWithStencilBox(currentRegion);
        if (ok) {
          lastLayoutRegion = currentRegion;
          lastLayoutWidth = window.innerWidth;
          lastLayoutHeight = window.innerHeight;
        }
      }

      if (
        stateTrackers.current.isStencilVisible !== true ||
        stateTrackers.current.activeStencil !== currentStencil
      ) {
        stateTrackers.current.isStencilVisible = true;
        stateTrackers.current.activeStencil = currentStencil;
        updateStencilDOM(
          currentStencil,
          true,
          stateTrackers.current.stencilColor,
        );
      }

      if (hold && hold2 && stateTrackers.current.stencilColor !== "#fff") {
        stateTrackers.current.stencilColor = "#fff";
        updateStencilDOM(currentStencil, true, "#fff");
      }

      const containerWidth = window.innerWidth;
      const containerHeight = window.innerHeight;
      const videoAspect = videoRef.current
        ? videoRef.current.videoWidth / videoRef.current.videoHeight || 1
        : 1;
      const containerAspect = containerWidth / containerHeight;
      let displayWidth, displayHeight;
      if (videoAspect > containerAspect) {
        displayWidth = containerWidth;
        displayHeight = containerWidth / videoAspect;
      } else {
        displayHeight = containerHeight;
        displayWidth = containerHeight * videoAspect;
      }

      const sWidth = displayWidth - 40;
      const sHeight = ["Side-Left", "Side-Right"].includes(currentRegion)
        ? displayHeight - 45
        : displayHeight - 40;
      const sLeft = (containerWidth - displayWidth) / 2 + 20;
      const sTop = ["Side-Left", "Side-Right"].includes(currentRegion)
        ? (containerHeight - displayHeight) / 2 + 22.5
        : (containerHeight - displayHeight) / 2 + 20;

      const xOffset = (containerWidth - displayWidth) / 2;
      const yOffset = (containerHeight - displayHeight) / 2;
      const scaleX = frameResolution / displayWidth;
      const scaleY = frameResolution / displayHeight;
      const topLeft = [(sLeft - xOffset) * scaleX, (sTop - yOffset) * scaleY];
      const bottomRight = [
        (sLeft + sWidth - xOffset) * scaleX,
        (sTop + sHeight - yOffset) * scaleY,
      ];

      if (currentRegion === currentStencil) {
        rightArrowVin.current.style.display = "none";
        leftArrowVin.current.style.display = "none";
        if (
          (stencilCheckInterval === undefined ||
            stencilCheckInterval === null) &&
          hold
        ) {
          stencilCheckInterval = setTimeout(() => {
            if (chooseRegionStencil.current.style.display !== "flex" && !hold) {
              clearInterval(imageFrameInterval);
              hold = false;

              stateTrackers.current.activeStencil = null;
              stateTrackers.current.isStencilVisible = false;
              updateStencilDOM(null, false, "#fff");

              upArrow.current.style.display = "none";
              downArrow.current.style.display = "none";
              leftFarArrow.current.style.display = "none";
              rightFarArrow.current.style.display = "none";
              leftNearArrow.current.style.display = "none";
              rightNearArrow.current.style.display = "none";
              displayText.current.innerHTML = "";
              displayText.current.style.display = "none";
              holdImage.current.style.display = "none";
              skipDiv.current.style.display = "flex";
            }
          }, 17000);
        }

        let value = goodFrame(
          topLeft,
          bottomRight,
          detections,
          currentRegion,
          currentAngle,
          frameResolution,
        );
        if (detectionBox.current) {
          detectionBox.current.innerHTML = "";
        }

        // detections.forEach((det) => {
        //   const [x, y, w, h] = det.bbox;
        //   drawBoxWithDiv(
        //     [x * frameResolution, y * frameResolution],
        //     [x * frameResolution + w * frameResolution, y * frameResolution + h * frameResolution],
        //     "blue",
        //   );
        // });
        // drawBoxWithDiv(value["maskMin"], value["maskMax"], "green");
        // partDataValue.current.innerHTML = JSON.stringify({
        //   ...value["part_list"],
        // });

        if (hold) {
          if (hold2 && value["partialDetction"] === true) {
            hold2 = false;

            stateTrackers.current.stencilColor = "#02CCFE";
            updateStencilDOM(currentStencil, true, "#02CCFE");

            captureStencilDialRed = [...captureStencilDialRed, currentRegion];
            imageFrameInterval = setInterval(() => {
              let b = captureImgFrame(true);
              if (b) {
                uploadImg(b);
              }
            }, 300);
            setTimeout(() => {
              clearInterval(imageFrameInterval);
            }, 1000);
          }
          if (value["flagValue"] === 0) {
            setHoldSkip(false);
            clearTimeout(InstructionClear);
            checkImageList = [];
            hold = false;
            checkLumaValue = true;
            clearTimeout(stencilCheckInterval);
            stencilCheckInterval = null;
            upArrow.current.style.display = "none";
            downArrow.current.style.display = "none";
            leftFarArrow.current.style.display = "none";
            rightFarArrow.current.style.display = "none";
            leftNearArrow.current.style.display = "none";
            rightNearArrow.current.style.display = "none";
            displayText.current.style.display = "flex";
            displayText.current.innerHTML = Object.keys(
              config["video-page"],
            ).includes("Hold this position for 3 seconds.")
              ? config["video-page"]["Hold this position for 3 seconds."]
              : getTranslateText("Hold this position for 3 seconds.");
            holdImage.current.style.display = "flex";
            setTimeout(() => {
              imageFrameInterval = setInterval(() => {
                let b = captureImgFrame(true);
                if (b) {
                  uploadImg(b);
                }
              }, 300);
            }, 1000);
            setTimeout(() => {
              clearInterval(imageFrameInterval);
              displayText.current.innerHTML = "";
              displayText.current.style.display = "none";
              frameUploadStencil = true;
              holdImage.current.style.display = "none";
              captureStencilDialGrren = [
                ...captureStencilDialGrren,
                currentRegion,
              ];

              stateTrackers.current.stencilColor = "#90EE90";
              updateStencilDOM(currentStencil, true, "#90EE90");

              setTimeout(() => {
                setHoldSkip(true);
              }, 500);
              setTimeout(() => {
                frameUploadStencil = false;

                setcapturedStencil((prevCaptured) => {
                  const updated = [...prevCaptured, currentRegion];
                  setalignStencil((prevAlign) => {
                    const alginAndFilterStencil = prevAlign.filter(
                      (item) => !updated.includes(item),
                    );
                    if (updated.length > 1) {
                      setmainRegion(alginAndFilterStencil[0]);
                      currentStencil = alginAndFilterStencil[0];
                    }
                    return alginAndFilterStencil;
                  });
                  if (updated.length === 1 && missedstep === false) {
                    currentStencil = "";
                    chooseRegionStencil.current.style.display = "flex";
                  }
                  if (updated.length > 7) {
                    currentStencil = "";
                    chooseRegionStencil.current.style.display = "flex";
                    upArrow.current.style.display = "none";
                    downArrow.current.style.display = "none";
                    leftFarArrow.current.style.display = "none";
                    rightFarArrow.current.style.display = "none";
                    leftNearArrow.current.style.display = "none";
                    rightNearArrow.current.style.display = "none";
                    displayText.current.innerHTML = "";
                    displayText.current.style.display = "none";
                  }
                  return updated;
                });

                detectionBox.current.style.display = "none";
                hold = true;
                hold2 = true;
                stencilImageDivRunOnce = true;
                stateTrackers.current.stencilColor = "#fff";
                updateStencilDOM(currentStencil, true, "#fff");
              }, 1000);
            }, 2000);
          }
          if (value["flagValue"] === 5) {
            checkImageList3.push(value["flagValue"]);
            checkImageList2 = [];
          }
          if (value["flagValue"] === 1 || value["flagValue"] === 2) {
            checkImageList.push(value["flagValue"]);
            checkImageList3 = [];
            checkImageList2 = [];
          }
          if (value["flagValue"] === -1) {
            checkImageList2.push(value["flagValue"]);
          }
          // partDataValueList.current.innerHTML = `Flag 1&2: ${checkImageList}<br>
          //   Flag 5: ${checkImageList3}<br>
          //   Flag -1: ${checkImageList2}<br>
          //   `;
          if (checkImageList.length > detectionFuncTime) {
            value["flagValue"] = getMaxItem(checkImageList);
            // partDataValueList.current.innerHTML =
            //   partDataValueList.current.innerHTML +
            //   `<br>final flag: ${value["flagValue"]}`;
            if (value["flagValue"] === 1) {
              clearTimeout(InstructionClear);
              upArrow.current.style.display = "none";
              downArrow.current.style.display = "none";
              leftNearArrow.current.style.display = "none";
              rightNearArrow.current.style.display = "none";
              leftFarArrow.current.style.display = "flex";
              rightFarArrow.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move away from the car")
                ? config["video-page"]["Move away from the car"]
                : getTranslateText("Move away from the car");
            } else if (value["flagValue"] === 2) {
              clearTimeout(InstructionClear);
              upArrow.current.style.display = "none";
              downArrow.current.style.display = "none";
              leftFarArrow.current.style.display = "none";
              rightFarArrow.current.style.display = "none";
              leftNearArrow.current.style.display = "flex";
              rightNearArrow.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move towards the car")
                ? config["video-page"]["Move towards the car"]
                : getTranslateText("Move towards the car");
            } else if (value["flagValue"] === 3) {
              clearTimeout(InstructionClear);
              leftNearArrow.current.style.display = "none";
              rightNearArrow.current.style.display = "none";
              leftFarArrow.current.style.display = "none";
              rightFarArrow.current.style.display = "none";
              downArrow.current.style.display = "none";
              upArrow.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move Up")
                ? config["video-page"]["Move Up"]
                : getTranslateText("Move Up");
            } else if (value["flagValue"] === 4) {
              clearTimeout(InstructionClear);
              leftNearArrow.current.style.display = "none";
              rightNearArrow.current.style.display = "none";
              leftFarArrow.current.style.display = "none";
              rightFarArrow.current.style.display = "none";
              upArrow.current.style.display = "none";
              downArrow.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move Down")
                ? config["video-page"]["Move Down"]
                : getTranslateText("Move Down");
            }
            if ([1, 2, 3, 4].includes(value["flagValue"])) {
              InstructionClear = setTimeout(() => {
                upArrow.current.style.display = "none";
                downArrow.current.style.display = "none";
                leftFarArrow.current.style.display = "none";
                rightFarArrow.current.style.display = "none";
                leftNearArrow.current.style.display = "none";
                rightNearArrow.current.style.display = "none";
                displayText.current.style.display = "flex";
                displayText.current.innerHTML = "";
              }, 3000);
            }
            checkImageList = [];
          }
          if (checkImageList3.length === 4) {
            clearTimeout(InstructionClear);
            checkImageList = [];
            leftNearArrow.current.style.display = "none";
            rightNearArrow.current.style.display = "none";
            leftFarArrow.current.style.display = "none";
            rightFarArrow.current.style.display = "none";
            upArrow.current.style.display = "none";
            downArrow.current.style.display = "none";
            displayText.current.style.display = "flex";
            displayText.current.innerHTML = Object.keys(
              config["video-page"],
            ).includes("Please adjust your camera to align with the stencils")
              ? config["video-page"][
              "Please adjust your camera to align with the stencils"
              ]
              : getTranslateText(
                "Please adjust your camera to align with the stencils",
              );
            checkImageList3 = [];
          }
          if (checkImageList2.length === 5) {
            clearTimeout(InstructionClear);
            checkImageList = [];
            upArrow.current.style.display = "none";
            downArrow.current.style.display = "none";
            leftFarArrow.current.style.display = "none";
            rightFarArrow.current.style.display = "none";
            leftNearArrow.current.style.display = "none";
            rightNearArrow.current.style.display = "none";
            displayText.current.style.display = "flex";
            displayText.current.innerHTML = Object.keys(
              config["video-page"],
            ).includes(
              "You're too close or too far — Fit the car edges to the stencil outline",
            )
              ? config["video-page"][
              "You're too close or too far — Fit the car edges to the stencil outline"
              ]
              : getTranslateText(
                "You're too close or too far — Fit the car edges to the stencil outline",
              );
            checkImageList2 = [];
          }
        }
      } else {
        if (stateTrackers.current.isStencilVisible === true) {
          upArrow.current.style.display = "none";
          downArrow.current.style.display = "none";
          leftFarArrow.current.style.display = "none";
          rightFarArrow.current.style.display = "none";
          leftNearArrow.current.style.display = "none";
          rightNearArrow.current.style.display = "none";
          let position = calculateUserPositions(currentRegion, currentStencil);
          switch (position) {
            case "right":
              rightArrowVin.current.style.display = "none";
              leftArrowVin.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move Left")
                ? config["video-page"]["Move Left"]
                : getTranslateText("Move Left");
              break;
            case "left":
              leftArrowVin.current.style.display = "none";
              rightArrowVin.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move Right")
                ? config["video-page"]["Move Right"]
                : getTranslateText("Move Right");
              break;
            case "same":
              leftArrowVin.current.style.display = "none";
              rightArrowVin.current.style.display = "none";
              break;
            default:
              leftArrowVin.current.style.display = "none";
              rightArrowVin.current.style.display = "none";
              displayText.current.style.display = "none";
              break;
          }
        }
      }
    } else {
      stateTrackers.current.isStencilVisible = false;
      stateTrackers.current.activeStencil = null;
      updateStencilDOM(null, false, "#fff");

      if (upArrow.current) upArrow.current.style.display = "none";
      if (downArrow.current) downArrow.current.style.display = "none";
      if (leftFarArrow.current) leftFarArrow.current.style.display = "none";
      if (rightFarArrow.current) rightFarArrow.current.style.display = "none";
      if (leftNearArrow.current) leftNearArrow.current.style.display = "none";
      if (rightNearArrow.current) rightNearArrow.current.style.display = "none";
      if (leftArrowVin.current) leftArrowVin.current.style.display = "none";
      if (rightArrowVin.current) rightArrowVin.current.style.display = "none";
      if (displayText.current) {
        displayText.current.style.display = "none";
        displayText.current.innerHTML = "";
      }
    }
  };

  const filterByLargerBbox = (detections) => {
    const bestDetections = {};
    const keepAll = ["wheel", "window_glass", "headlight", "taillight"];
    detections.forEach((det) => {
      const label = det.label;
      const [x, y, w, h] = det.bbox;
      const area = w * h;
      if (keepAll.includes(label)) {
        if (!(label in bestDetections)) {
          bestDetections[label] = [];
        }
        bestDetections[label].push({ area, det });
      } else {
        if (!(label in bestDetections)) {
          bestDetections[label] = { area, det };
        } else {
          if (area > bestDetections[label].area) {
            bestDetections[label] = { area, det };
          }
        }
      }
    });
    return Object.values(bestDetections).flatMap((entry) =>
      Array.isArray(entry) ? entry.map((e) => e.det) : entry.det,
    );
  };

  const isImageSharp = (base64) => {
    uploadImgInterim(base64);
  };

  const detectFrame = async (video, model) => {
    if (!active || !videoRef.current) return;
    // Rate-cap the loop (see minDetectIntervalMs above). Skipped iterations
    // just reschedule; the timestamp check is ~free.
    const nowTs = Date.now();
    if (nowTs - lastDetectIterationTs < minDetectIntervalMs) {
      if (active && videoRef.current) requestAnimationFrame(() => detectFrame(video, model));
      return;
    }
    lastDetectIterationTs = nowTs;
    if (Object.values(data.regionsCovered).every((val) => val !== 0)) {
      setAllSideCoveredVideo(true);
    }

    let newImgURL = captureImgFrame(false);

    await tf.nextFrame();

    if (newImgURL) {
      if (getTimeonce) {
        getTimeonce = false;
        startTimeModel = performance.now();
      }
      let detections = [];
      // Off-main-thread inference when available (same recipe as NewVideo):
      // the worker runs the same model on the same 128x128 input (accuracy
      // unchanged); if it isn't ready or has died, the original main-thread
      // path below runs instead.
      const inferenceWorker = !(
        Object.keys(config).includes("int8Model") && config["int8Model"]
      )
        ? getSharedInferenceWorker("car")
        : null;
      const useWorker = !!(
        inferenceWorker &&
        inferenceWorker.ready &&
        inferenceWorker.isAlive()
      );
      // Worker path keeps all tensors inside the worker -> no engine scope.
      !useWorker &&
        !Object.keys(config).includes("int8Model") &&
        tf.engine().startScope();
      if (detectMlCheck) {
        detectMlCheck = false;
        patLogs("part_detection_is_working", inspectionId);
      }
      try {
        // Inference timing: from the raw frame going in to detections coming out.
        // const inferStart = performance.now(); // DEBUG (commented out)
        let processedFrame;
        if (useWorker) {
          // One transferred ImageBitmap in; plain detections + the low-light
          // channel means out (no tensors cross the boundary).
          const res = await inferenceWorker.detect(video);
          if (!active || !videoRef.current) return;
          detections = res.detections;
          processedFrame = makeLowLightFrameShim(res.rgbMeans);
        } else {
          const ctx = resizeCtxRef.current;
          const canvas = resizeCanvasRef.current;
          if (!ctx || !canvas) return;

          ctx.drawImage(video, 0, 0, 320, 320);

          processedFrame =
            Object.keys(config).includes("int8Model") && config["int8Model"]
              ? preprocessVideo(canvas)
              : partDetector.processInput(video);

          await tf.nextFrame();

          const predictions =
            Object.keys(config).includes("int8Model") && config["int8Model"]
              ? ""
              : await model.executeAsync(processedFrame);

          if (!active || !videoRef.current) {
            if (processedFrame && !processedFrame.isDisposedInternal) {
              processedFrame.dispose();
            }
            if (!Object.keys(config).includes("int8Model")) {
              tf.engine().endScope();
            }
            return;
          }

          await tf.nextFrame();

          detections =
            Object.keys(config).includes("int8Model") && config["int8Model"]
              ? await runCarPartDetection(model, processedFrame)
              : partDetector.getDetectionObjects(predictions);
        }

        /* ---- DEBUG LOGS (commented out) ----
        const inferMs = performance.now() - inferStart;
        console.log(
          `[inference] frame→detections: ${inferMs.toFixed(2)} ms — ${detections.length} detections`,
        );
        if (inferenceTimeRef.current) {
          inferenceTimeRef.current.innerHTML = `${inferMs.toFixed(1)} ms · ${detections.length} det`;
        }
        // Live detections log: show each detection's class id, label and score
        // exactly as the int8 model (runCarPartDetection) produced them.
        if (detectionLogRef.current) {
          const detLog = (detections || [])
            .map(
              (d) =>
                `${d.class !== undefined ? "#" + d.class + " " : ""}${d.label}` +
                `${d.score !== undefined ? " " + Number(d.score).toFixed(2) : ""}`,
            )
            .join("<br/>");
          detectionLogRef.current.innerHTML =
            `<b>Detections (${detections.length}):</b><br/>${detLog || "-"}`;
        }
        // Van / non_van flag: these classes are filtered out of detections in
        // NewPartDetector (used only to pick the threshold set), so read the
        // exposed classification directly to show what the model is seeing.
        if (vanFlagRef.current) {
          const vi = getLastVanInfo();
          vanFlagRef.current.style.background =
            vi.result === "van"
              ? "rgba(0, 150, 0, 0.85)"
              : vi.result === "non_van"
                ? "rgba(180, 0, 0, 0.85)"
                : "rgba(0, 0, 0, 0.6)";
          vanFlagRef.current.innerHTML =
            `van ${vi.van ? vi.van.toFixed(2) : "-"} | ` +
            `non_van ${vi.nonVan ? vi.nonVan.toFixed(2) : "-"} → ` +
            `<b>${vi.result.toUpperCase()}</b>`;
        }
        // Cold start: time from the first detection-loop frame (startTimeModel)
        // to the first frame that actually produces a detection.
        if (coldStartOnce && detections.length > 0) {
          coldStartOnce = false;
          if (coldStartTimeRef.current) {
            coldStartTimeRef.current.innerHTML = `cold: ${(
              performance.now() - startTimeModel
            ).toFixed(1)} ms`;
          }
        }
        ---- end DEBUG LOGS ---- */

        const filteredDetections = filterByLargerBbox(detections);

        let [
          currentAngle,
          currentRegion,
          regionsCoveredMap,
          feedbacks,
          videoFreezeStatus,
          currentNudge,
          imgURL,
          allowImgURL,
          frameCountPerRegion,
          revolutionRegionCurrent,
          realGyroAngle,
          angleRF,
        ] = guidance.performChecksAndGetWarningMessage(
          filteredDetections,
          processedFrame,
          newImgURL,
        );
        const endTimeModel = performance.now();

        if (processedFrame && !processedFrame.isDisposedInternal) {
          processedFrame.dispose();
        }

        data = {
          text: feedbacks[feedbacks.length - 1],
          feedbacks: feedbacks,
          regionsCovered: regionsCoveredMap,
          angle: currentAngle !== -1 ? currentAngle : data.angle,
          region: currentRegion,
          nudges: currentNudge,
        };
        // partData.current.innerHTML = JSON.stringify({
        //   "rf Angle": angleRF,
        //   "normal gyro angle": realGyroAngle,
        //   "new logic gyro angle": data.angle,
        // });

        if (Object.values(regionsCoveredMap).some((value) => value > 0)) {
          if (staticRegion === "") {
            displayText.current.style.display = "none";
            displayText.current.innerHTML = "";
            staticRegion = currentRegion;
            setmainRegion(staticRegion);
          }
          updateStencilValue(
            currentRegion,
            detections,
            realGyroAngle,
            currentAngle,
          );

          instImage.current.style.display = "none";
          if (previousAngle.includes(currentAngle)) {
            previousAngle = previousAngle.filter(
              (item) => item !== currentAngle,
            );
            const now = performance.now();
            if (now - lastSharpCheck > 500) {
              let c = captureImgFrame(true);
              if (c) {
                isImageSharp(c);
              }
              lastSharpCheck = now;
            }
          }
        }
        captureStencilDialGrren.map((e) => {
          if (captureStencilDialRed.includes(e)) {
            captureStencilDialRed = captureStencilDialRed.filter(
              (item) => item !== e,
            );
          }
          if (Object.keys(showCoveredRegion).includes(e)) {
            showCoveredRegion[e] = 2;
          }
        });
        captureStencilDialRed.map((e) => {
          if (Object.keys(showCoveredRegion).includes(e)) {
            showCoveredRegion[e] = 1;
          }
        });
        // console.log(canvas1.current, data.angle, showCoveredRegion, clientId)
        drawArc(canvas1.current, data.angle, showCoveredRegion, clientId);

        allRegionsCovered = guidance.checkIfAllRegionsCovered();

        finalRegionsMap = showCoveredRegion;
        allowImgURLmain = allowImgURL;
        regionWiseData = frameCountPerRegion;
        actualGuidanceRegion = guidance.actualPartsCoveredMap;
        Object.keys(actualGuidanceRegion).map((e) => {
          allActualRegionDataLog.key = e;
          let takeOutValue = [];
          actualGuidanceRegion[e].forEach((i) => {
            takeOutValue.push(i);
          });
          allActualRegionDataLog[e] = takeOutValue;
        });
        if (!angleDetectedGyro.includes(currentAngle)) {
          angleDetectedGyro.push(currentAngle !== -1 ? currentAngle : 0);
        }
        if (
          JSON.stringify(showCoveredRegion) !==
          JSON.stringify(showCoveredRegioncheck)
        ) {
          sendCoveredArea(
            allGreen,
            showCoveredRegion,
            clientId,
            caseId,
            inspectionId,
          );
          showCoveredRegioncheck = showCoveredRegion;
        }
        if (
          JSON.stringify(allActualRegionDataLog) !==
          JSON.stringify(allActualRegionDataLogsCheck)
        ) {
          allActualRegionDataLog["VideoTimer"] = `${minutes} : ${seconds}`;
          allActualRegionDataLog["angleDetected"] = angleDetectedGyro;
          allActualRegionDataLog["DialStatus"] = showCoveredRegion;
          userLogs({
            position: 3,
            video_data: JSON.stringify(allActualRegionDataLog),
            inspectionId,
          });
          allActualRegionDataLogsCheck = allActualRegionDataLog;
        }


        if (consoleOnceModel && Object.keys(config).includes("int8Model")) {
          consoleOnceModel = false;
          coldStartText = `<br> Cold start: ${(endTimeModel - startTimeModel).toFixed(2)} ms`;
        }

        if (
          detectOnce &&
          Object.values(regionsCoveredMap).some((value) => value > 0) &&
          Object.keys(config).includes("int8Model")
        ) {
          detectOnce = false;
          regionDetectedText = `<br> Region detected: ${(endTimeModel - startTimeModel).toFixed(2)} ms`;
        }

      } catch (err) {
        // console.log("Error during detection:", err);
        let backendErrorPatterns = [
          /gl.*lost/i,
          /webgl.*context/i,
          /compile.*shader/i,
          /link.*shader/i,
          /link.*program/i,
          /vertex.*shader/i,
          /fragment.*shader/i,
          /failed.*shader/i,
          /webgl.*error/i,
          /webgpu/i,
          /device.*lost/i,
          /cannot.*create.*gpu/i,
          /gpu.*error/i,
          /wasm.*memory.*error/i,
          /memory.*access/i,
          /invalid.*memory/i,
          /cpu.*execution.*failed/i,
          /backend.*error/i,
          /backend.*failure/i,
          /tensor.*backend.*error/i,
          /unexpected.*backend/i,
        ];
        if (backendErrorPatterns.some((regex) => regex.test(err.message))) {
          const fallbackBackend =
            tf.engine().backendName === "webgl" ? "webgpu" : "cpu";
          await setBackendExternally(fallbackBackend);
        }
        if (
          getRedirectVideoToImgFlag() &&
          !backendErrorPatterns.some((regex) => regex.test(err.message))
        ) {
          patLogs(
            `Error from detect Frame ${err.message} ,${err.stack}`,
            inspectionId,
          );
          setErrorType(true);
          if (skipDivFallback.current) skipDivFallback.current.style.display = "flex";
        }
      } finally {
        !useWorker &&
          !Object.keys(config).includes("int8Model") &&
          tf.engine().endScope();
      }
    }

    if (active && videoRef.current) {
      requestAnimationFrame(() => detectFrame(video, model));
    }
  };

  const checklandScape = () => {
    startRefCheck = setInterval(() => {
      if (!isLandscape()) {
        if (warnRef.current) warnRef.current.style.display = "flex";
        if (startRef.current) startRef.current.style.display = "none";
      } else {
        if (warnRef.current) warnRef.current.style.display = "none";
        if (startRef.current) startRef.current.style.display = "flex";
      }
    }, 200);
  };
  const updateUI = () => {
    if (warnRef.current) {
      warnRef.current.style.display = isLandscape() ? "none" : "flex";
    }
    if (seconds >= 60) {
      minutes++;
      seconds = 0;
    }
    const videoLabel =
      config["video-page"]["Video"] || getTranslateText("Video");
    const secLabel = config["video-page"]["sec"] || getTranslateText("sec");
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    if (timerRef.current) {
      timerRef.current.innerText = `${videoLabel} ${formattedMinutes}:${formattedSeconds} ${secLabel}`;
    }
  };

  const startCameraLocal = () => {
    leftArrowVin.current.style.display = "none";
    rightArrowVin.current.style.display = "none";
    detectionBox.current.style.display = "none";
    holdImage.current.style.display = "none";
    displayText.current.style.display = "none";
    stencilImageDiv.current.style.display = "none";
    chooseRegionStencil.current.style.display = "none";
    upArrow.current.style.display = "none";
    downArrow.current.style.display = "none";
    document.getElementById("window-arc2").style.visibility = "hidden";
    cardRef.current.style.display = "none";
    warnRef.current.style.display = "none";
    imgRef.current.style.display = "block";
    loaderGuidanceText.current.innerHTML = config["video-page"]["loadingText"];
    drawArc(canvas1.current, data.angle, data.regionsCovered, clientId);
    webCamPromise = navigator.mediaDevices
      .getUserMedia(getConstraint(config, clientId))
      .then((stream) => {
        window.stream = stream;
        track = stream.getTracks()[0];
        videoRef.current.srcObject = stream;
        // camera started -> start recording (only if config.recordVideo === true)
        startCarVideoRecording({
          config,
          clientId,
          videoEl: videoRef.current,
          inspectionId,
          token,
          isIos,
        });
        document.getElementById("window-arc2").style.visibility = "visible";
        return new Promise(
          (resolve, _) => (videoRef.current.onloadedmetadata = () => resolve()),
        );
      })
      .catch((err) => {
        // console.error(err);
      });
  };

  const checkForRedirect = () => {
    if (getRedirectVideoToImgFlag()) {
      setTimeout(() => {
        let b = angleDetectedGyro.filter((num) => num !== 0);
        if (
          errorType !== true &&
          Object.values(data.regionsCovered).every((val) => val === 0)
        ) {
          if (
            Object.values(finalRegionsMap).filter(
              (value) => value === 1 || value === 2,
            ).length <= 0
          ) {
            setErrorType(false);
            skipDivFallback.current.style.display = "flex";
            patLogs("No detection happen", inspectionId);
          }
        } else if (
          errorType !== true &&
          Object.values(data.regionsCovered).some(
            (val) => val === 1 || val === 2,
          ) &&
          b.length < 5
        ) {
          patLogs(
            "detection happen but gyro value is not comming",
            inspectionId,
          );
          patLogs(`gyro values detected are: ${b}`, inspectionId);
          setErrorType(false);
          skipDivFallback.current.style.display = "flex";
        }
      }, 60000);
    }
  };

  const startRecording = () => {
    checkForRedirect();
    displayText.current.style.display = "flex";
    instImage.current.style.display = "flex";
    displayText.current.innerHTML = Object.keys(config["video-page"]).includes(
      "Calculating angle. Please point the camera at the car.",
    )
      ? config["video-page"][
      "Calculating angle. Please point the camera at the car."
      ]
      : getTranslateText(
        "Calculating angle. Please point the camera at the car.",
      );
    patLogs("camera button clicked", inspectionId);
    cardRef.current.style.display = "flex";
    sendLogData({ position: 9, record_button: "yes", inspectionId });
    startRef.current.style.display = "none";
    // Warm the off-thread inference worker in parallel with the main-thread
    // model load; detectFrame switches to it once ready (and falls back to
    // the main-thread model seamlessly if it can't run on this browser).
    getSharedInferenceWorker("car");
    minDetectIntervalMs = Object.keys(config["video-page"]).includes(
      "detectIntervalMs",
    )
      ? config["video-page"]["detectIntervalMs"]
      : 250;
    // const modelInitStart = performance.now(); // DEBUG (commented out)
    Promise.all([getModel(), webCamPromise])
      .then((values) => {
        clearInterval(startRefCheck);
        sendLogData({ position: 6, model_initialized: "yes", inspectionId });
        if (Object.keys(config).includes("int8Model")) {
          model = values[0]["model"];
          showResult.current.innerHTML =
            showResult.current.innerHTML +
            ` <br> Loading time: ${values[0]["time"]} ms `;
          /* DEBUG LOG (commented out)
          if (modelInitTimeRef.current) {
            modelInitTimeRef.current.innerHTML = `init: ${Number(
              values[0]["time"],
            ).toFixed(1)} ms`;
          }
          */
        } else {
          model = values[0];
          /* DEBUG LOG (commented out)
          if (modelInitTimeRef.current) {
            modelInitTimeRef.current.innerHTML = `init: ${(
              performance.now() - modelInitStart
            ).toFixed(1)} ms`;
          }
          */
        }
        detectFrame(videoRef.current, model);
        cardRef.current.style.display = "none";
        startTimer = setInterval(() => {
          seconds++;
          endTimer++;
          requestAnimationFrame(() => updateUI());
        }, 1000);
        setCurrentPage("Model initialize");
      })
      .catch((error) => {
        // console.log(error);
        if (getRedirectVideoToImgFlag()) {
          patLogs(`Model realted problem ${error.message}`, inspectionId);
          setErrorType(true);
          skipDivFallback.current.style.display = "flex";
        }
        sendLogData({
          position: 6,
          model_initialized: `no - ${error.message}`,
          inspectionId,
        });
        setCurrentPage("Model not initialize");
      });
  };

  const stopRecording = async (clicked, submitFlag) => {
    clearInterval(frameInterval);
    sendCoveredArea(allGreen, finalRegionsMap, clientId, caseId, inspectionId);
    if (!typeof actualGuidanceRegion === "undefined") {
      Object.keys(actualGuidanceRegion).map((e) => {
        allActualRegionData.key = e;
        let takeOutValue = [];
        actualGuidanceRegion[e].forEach((i) => {
          takeOutValue.push(i);
        });
        allActualRegionData[e] = takeOutValue;
      });
    }
    allActualRegionData["VideoTimer"] = `${minutes} : ${seconds}`;
    allActualRegionData["angleDetected"] = angleDetectedGyro;
    allActualRegionData["lowLightImage"] = WholeLightLumaData;
    allActualRegionData["DialStatus"] = finalRegionsMap;
    allActualRegionData["currentUploadedPartCount"] = currentUploadedPartCount;
    actualRegion(allActualRegionData, inspectionId);
    setImgCOunt(inspectionId, {
      regionWiseData,
      afterFrameimgValue,
      imgValue,
      ...allowImgURLmain,
      allActualRegionData,
    });
    stopRecordingML = true;
    patLogs("stop recording clicked", inspectionId);
    // camera stopping -> stop recording and upload the video
    stopCarVideoRecordingAndUpload();
    active = false;
    clearInterval(startTimer);
    window.stream = null;
    track.stop();
    delete allActualRegionData.lowLightImage;
    userLogs({
      position: 3,
      video_data: JSON.stringify(allActualRegionData),
      inspectionId,
    });
    handleNext();
  };

  const back = () => {
    logbugs = true;
    // camera closing -> stop recording and upload the video
    stopCarVideoRecordingAndUpload();
    window.stream = null;
    track.stop();
    patLogs("clicked back button", inspectionId);
    if (["opes_prod", "opes_uat"].includes(clientId)) {
      setScreen("menuOpes");
    } else {
      setScreen("menu");
    }
  };

  const handleNext = () => {
    logbugs = false;
    patLogs("video module is completed", inspectionId);
    setTimeout(() => {
      if (currentBlock["mandatory"] && captured > 0) {
        let temp1 = mandatory;
        temp1[currentBlock["id"]] = "completed";
        setMandatory(temp1);
      }
      if (captured > 0) {
        let temp = condition;
        temp[currentBlock["id"]] = "completed";
        setCondition(temp);
        setLog(`${currentBlock["tag"]} was captured`);
        resumeFlowFinalSubmitHandler(currentBlock["id"]);
      }
      setPortoModuleComplete(currentBlock["tag"])
      if (["opes_prod", "opes_uat"].includes(clientId)) {
        setScreen("menuOpes");
      } else {
        if (Object.keys(config).includes("directModule")) {
          setScreen("success");
        } else {
          setScreen("menu");
        }
      }
    }, 1000);
  };

  const alignAllStencilAccordingUser = (e, position) => {
    const items = Object.keys(regionStencil);
    const index = items.indexOf(e);
    let res;
    if (index === -1) {
      res = [];
    } else if (position === "right") {
      res = [...items.slice(index), ...items.slice(0, index)];
    } else if (position === "left") {
      const left = items.slice(0, index + 1).reverse();
      const right = items.slice(index + 1).reverse();
      res = [...left, ...right];
    } else {
      res = [];
    }
    return res;
  };

  const missedCheckedStep = (e) => {
    missedstep = true;
    const nextStencil = [...skipStencil];
    setalignStencil(nextStencil);
    if (nextStencil.length > 0) {
      setmainRegion(nextStencil[0]);
      currentStencil = nextStencil[0];
      stateTrackers.current.stencilColor = "#fff";
      updateStencilDOM(currentStencil, true, "#fff");
    }
    setcapturedStencil((prev) =>
      prev.filter((item) => !skipStencil.includes(item)),
    );
    setSkipStencil([]);
    chooseRegionStencil.current.style.display = "none";
  };

  const checkStep = (e) => {
    hold = true;
    hold2 = true;
    if (e === "previous") {
      setalignStencil(
        alignAllStencilAccordingUser(
          Object.keys(regionStencil)[
          Object.keys(regionStencil).indexOf(mainRegion) === 0
            ? 7
            : Object.keys(regionStencil).indexOf(mainRegion) - 1
          ],
          "left",
        ),
      );
      setmainRegion(
        Object.keys(regionStencil)[
        Object.keys(regionStencil).indexOf(mainRegion) === 0
          ? 7
          : Object.keys(regionStencil).indexOf(mainRegion) - 1
        ],
      );
      currentStencil =
        Object.keys(regionStencil)[
        Object.keys(regionStencil).indexOf(mainRegion) === 0
          ? 7
          : Object.keys(regionStencil).indexOf(mainRegion) - 1
        ];
      chooseRegionStencil.current.style.display = "none";
    } else if (e === "after") {
      setalignStencil(
        alignAllStencilAccordingUser(
          Object.keys(regionStencil)[
          Object.keys(regionStencil).indexOf(mainRegion) === 7
            ? 0
            : Object.keys(regionStencil).indexOf(mainRegion) + 1
          ],
          "right",
        ),
      );
      setmainRegion(
        Object.keys(regionStencil)[
        Object.keys(regionStencil).indexOf(mainRegion) === 7
          ? 0
          : Object.keys(regionStencil).indexOf(mainRegion) + 1
        ],
      );
      currentStencil =
        Object.keys(regionStencil)[
        Object.keys(regionStencil).indexOf(mainRegion) === 7
          ? 0
          : Object.keys(regionStencil).indexOf(mainRegion) + 1
        ];
      stateTrackers.current.stencilColor = "#fff";
      updateStencilDOM(currentStencil, true, "#fff");
      chooseRegionStencil.current.style.display = "none";
    } else if (e === "next") {
      chooseRegionStencil.current.style.display = "none";
    }
  };

  useEffect(() => {
    if (instImage.current) instImage.current.style.display = "none";
    const canvas = document.createElement("canvas");
    canvas.width = 320;
    canvas.height = 320;
    resizeCanvasRef.current = canvas;
    resizeCtxRef.current = canvas.getContext("2d", {
      willReadFrequently: true,
    });
  }, []);

  useEffect(() => {
    checklandScape();
    setStopPing(null);
    startCameraLocal();

    const onResize = () => {
      lastLayoutRegion = null;
      lastLayoutWidth = 0;
      lastLayoutHeight = 0;
      if (currentStencil) setupVideoWithStencilBox(currentStencil);
    };
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      active = false;
      clearInterval(startTimer);
      clearInterval(imageFrameInterval);
      clearInterval(startRefCheck);
      if (track) {
        try {
          track.stop();
        } catch (e) {
          // console.log("Error stopping track in useEffect cleanup:", e);
        }
      }
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);

  return (
    <div
      id="screen3"
      ref={screen3}
      style={{ position: "relative", height: "100dvh" }}
    >
      {/* ---- DEBUG PANELS (commented out) ----
      <div
        ref={vanFlagRef}
        style={{
          position: "absolute",
          top: "8px",
          right: "8px",
          margin: 0,
          padding: "4px 8px",
          background: "rgba(0, 0, 0, 0.6)",
          color: "#fff",
          font: "12px/1.4 monospace",
          borderRadius: "4px",
          zIndex: 6,
          pointerEvents: "none",
        }}
      ></div>
      <div
        ref={detectionLogRef}
        style={{
          position: "absolute",
          top: "8px",
          left: "8px",
          maxWidth: "45vw",
          maxHeight: "60vh",
          overflowY: "auto",
          margin: 0,
          padding: "6px 8px",
          background: "rgba(0, 0, 0, 0.6)",
          color: "#fff",
          font: "11px/1.4 monospace",
          borderRadius: "4px",
          zIndex: 5,
          pointerEvents: "auto",
        }}
      ></div>
      <p
        ref={coldStartTimeRef}
        style={{
          position: "absolute",
          bottom: "60px",
          right: "8px",
          margin: 0,
          padding: "4px 8px",
          background: "rgba(0, 0, 0, 0.6)",
          color: "#ffab40",
          font: "12px/1.4 monospace",
          borderRadius: "4px",
          zIndex: 5,
          pointerEvents: "none",
        }}
      ></p>
      <p
        ref={modelInitTimeRef}
        style={{
          position: "absolute",
          bottom: "34px",
          right: "8px",
          margin: 0,
          padding: "4px 8px",
          background: "rgba(0, 0, 0, 0.6)",
          color: "#40c4ff",
          font: "12px/1.4 monospace",
          borderRadius: "4px",
          zIndex: 5,
          pointerEvents: "none",
        }}
      ></p>
      <p
        ref={inferenceTimeRef}
        style={{
          position: "absolute",
          bottom: "8px",
          right: "8px",
          margin: 0,
          padding: "4px 8px",
          background: "rgba(0, 0, 0, 0.6)",
          color: "#00e676",
          font: "12px/1.4 monospace",
          borderRadius: "4px",
          zIndex: 5,
          pointerEvents: "none",
        }}
      ></p>
      ---- end DEBUG PANELS ---- */}
      <p
        ref={showResult}
        style={{
          display: "none",
          position: "absolute",
          top: "0%",
          left: "0%",
          backgroundColor: "white",
          zIndex: 2,
        }}
      ></p>
      <img
        src={HoldSvg}
        ref={instImage}
        px
        style={{
          position: "absolute",
          top: "70%",
          left: "50%",
          zIndex: 2,
          height: "100px",
          width: "100px",
          transform: "translate(-50%, -70%)",
        }}
      />
      <canvas
        ref={canvasRef}
        id="ios-canvas"
        style={
          getAspectRatioClientList(clientId, config)
            ? {
              width: "100vw",
              height: "100vh",
              objectFit: "contain",
              backgroundColor: "black",
              position: "absolute",
              top: 0,
              left: 0,
            }
            : { position: "absolute", top: 0, left: 0 }
        }
      ></canvas>
      <video
        ref={videoRef}
        id="videoWindow"
        style={
          getAspectRatioClientList(clientId, config)
            ? {
              width: "100vw",
              height: "100vh",
              objectFit: "contain",
              backgroundColor: "black",
              position: "absolute",
              top: 0,
              left: 0,
            }
            : { position: "absolute", top: 0, left: 0 }
        }
        autoPlay
        playsInline
      ></video>
      <div className="video-instructions-stencil">
        <p ref={timerRef}></p>
        <div className="video-instructions-stencil-div">
          <div>
            {Object.keys(config["video-page"]).includes("REC")
              ? config["video-page"]["REC"]
              : getTranslateText("REC")}
          </div>
        </div>
      </div>

      <div id="window-arc2">
        <img src={carsmall} alt="" className="car" />
        <canvas ref={canvas1} width="100" height="100"></canvas>
      </div>

      <div ref={startRef} className="startPopupStecil">
        <div className="startPopupStecilDiv2">
          <img src={StencilInst} />
        </div>
        <div className="startPopupStecilDiv">
          <div>
            <p style={{ fontWeight: 600 }}>
              {Object.keys(config["video-page"]).includes(
                "Circle around the car to record the video and position the car within the stencil to auto capture photos.",
              )
                ? config["video-page"][
                "Circle around the car to record the video and position the car within the stencil to auto capture photos."
                ]
                : getTranslateText(
                  "Circle around the car to record the video and position the car within the stencil to auto capture photos.",
                )}
            </p>
          </div>
          <button
            onClick={startRecording}
            style={{ backgroundColor: config["colors"]["btn"] }}
          >
            {Object.keys(config["video-page"]).includes("GET STARTED")
              ? config["video-page"]["GET STARTED"]
              : getTranslateText("GET STARTED")}
          </button>
        </div>
      </div>

      <div ref={cardRef} id="display-card">
        <div className="pre-start-card">
          <strong
            style={{
              marginRight: "2px",
              fontSize: "12px",
              transform: "rotate(-90deg)",
            }}
          >
            {config["video-page"]["left-text"]}
          </strong>
          <div className="car-flex">
            <strong
              style={{
                marginBottom: "8px",
                textAlign: "center",
                fontSize: "12px",
              }}
            >
              {config["video-page"]["front-text"]}
            </strong>
            <img ref={imgRef} style={{ width: "12dvw" }} src={initRedImg}></img>
            <strong style={{ marginTop: "10px", fontSize: "12px" }}>
              {config["video-page"]["rear-text"]}
            </strong>
          </div>
          <strong style={{ fontSize: "12px", transform: "rotate(90deg)" }}>
            {config["video-page"]["right-text"]}
          </strong>
          <div style={{ width: "20px" }}></div>
        </div>
        <div className="card-info">
          <div>
            <div className="car-green"></div>
            <b style={{ fontSize: "14px" }}>
              {config["video-page"]["covered-text"]}
            </b>
          </div>
          <div>
            <div
              className="car-red"
              style={{ backgroundColor: "#de524c" }}
            ></div>
            <b style={{ fontSize: "14px" }}>
              {config["video-page"]["notcovered-text"]}
            </b>
          </div>
          <div className="card-note">
            <p
              ref={loaderGuidanceText}
              style={{ width: "100%", fontSize: "14px" }}
            ></p>
            <img
              id="model-loader"
              src="https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/video_model_loader.gif"
              alt="abc"
            />
          </div>
        </div>
      </div>

      <div className="chooseRegionStencil" ref={chooseRegionStencil}>
        {skipStencil.length > 0 &&
          Object.keys(config["video-page"]).includes("restrictUser") ? (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Press continue to capture the missed sections",
            )
              ? config["video-page"][
              "Press continue to capture the missed sections"
              ]
              : getTranslateText(
                "Press continue to capture the missed sections",
              )}
          </h3>
        ) : skipStencil.length > 0 ? (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Continue to capture missed sections, or proceed without them.",
            )
              ? config["video-page"][
              "Continue to capture missed sections, or proceed without them."
              ]
              : getTranslateText(
                "Continue to capture missed sections, or proceed without them.",
              )}
          </h3>
        ) : capturedStencil.length > 7 ? (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "All sides of the car is captured",
            )
              ? config["video-page"]["All sides of the car is captured"]
              : getTranslateText("All sides of the car is captured")}
          </h3>
        ) : (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Select left or right to move around the car.",
            )
              ? config["video-page"][
              "Select left or right to move around the car."
              ]
              : getTranslateText(
                "Select left or right to move around the car.",
              )}
          </h3>
        )}
        {skipStencil.length > 0 && (
          <div className="missedList">
            <ul className="missedListUl">
              {skipStencil.map((e, index) => (
                <li key={index}>
                  {Object.keys(config["video-page"]["region"]).includes(e)
                    ? config["video-page"]["region"][e]
                    : getTranslateText(e)}
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className="alignButtons">
          {skipStencil.length > 0 && (
            <div
              style={{ backgroundColor: config["colors"]["btn"] }}
              className="StopRecording"
              onClick={() => {
                missedCheckedStep();
              }}
            >
              <p>
                {Object.keys(config["video-page"]).includes("Continue")
                  ? config["video-page"]["Continue"]
                  : getTranslateText("Continue")}
              </p>
            </div>
          )}
          {Object.keys(config["video-page"]).includes("restrictUser") &&
            config["video-page"]["restrictUser"] &&
            skipStencil.length === 0 &&
            capturedStencil.length > 7 && (
              <div
                style={{ backgroundColor: config["colors"]["btn"] }}
                className="StopRecording"
                onClick={() => {
                  stopRecording();
                }}
              >
                <p>
                  {Object.keys(config["video-page"]).includes("Stop recording")
                    ? config["video-page"]["Stop recording"]
                    : getTranslateText("Stop recording")}
                </p>
              </div>
            )}
          {!(
            Object.keys(config["video-page"]).includes("restrictUser") &&
            config["video-page"]["restrictUser"]
          ) &&
            capturedStencil.length > 7 && (
              <div
                className="StopRecording"
                style={{ backgroundColor: config["colors"]["btn"] }}
                onClick={() => {
                  stopRecording();
                }}
              >
                <p>
                  {Object.keys(config["video-page"]).includes("Stop recording")
                    ? config["video-page"]["Stop recording"]
                    : getTranslateText("Stop recording")}
                </p>
              </div>
            )}
        </div>
        {capturedStencil.length < 7 && (
          <div className="regionModule">
            <div
              className="regionModuleDiv"
              onClick={() => {
                checkStep("previous");
              }}
            >
              <img
                src={
                  regionIcon[
                  Object.keys(regionStencil)[
                  Object.keys(regionStencil).indexOf(mainRegion) === 0
                    ? 7
                    : Object.keys(regionStencil).indexOf(mainRegion) - 1
                  ]
                  ]
                }
                className="regionModuleimg"
                style={{ border: "1px solid black" }}
              />
              <div
                className="regionButton"
                style={{ backgroundColor: config["colors"]["btn"] }}
              >
                <img
                  style={{
                    height: "18px",
                    width: "30px",
                    transform: "rotate(-180deg)",
                  }}
                  src={nearFarArrow}
                />
                <p>
                  {Object.keys(config["video-page"]).includes("Left")
                    ? config["video-page"]["Left"]
                    : getTranslateText("Left")}
                </p>
              </div>
            </div>
            <div className="regionModuleDiv">
              <img
                src={regionIcon[mainRegion]}
                style={{ border: "2px solid #13da0e" }}
                className="regionModuleimg"
              />
              <h3 style={{ width: "100%", marginTop: "10%" }}>
                {Object.keys(config["video-page"]["region"]).includes(
                  mainRegion,
                )
                  ? config["video-page"]["region"][mainRegion]
                  : getTranslateText(mainRegion)}
              </h3>
            </div>
            <div
              className="regionModuleDiv"
              onClick={() => {
                checkStep("after");
              }}
            >
              <img
                className="regionModuleimg"
                src={
                  regionIcon[
                  Object.keys(regionStencil)[
                  Object.keys(regionStencil).indexOf(mainRegion) === 7
                    ? 0
                    : Object.keys(regionStencil).indexOf(mainRegion) + 1
                  ]
                  ]
                }
                style={{ border: "1px solid black" }}
              />
              <div
                className="regionButton"
                style={{ backgroundColor: config["colors"]["btn"] }}
              >
                <p>
                  {Object.keys(config["video-page"]).includes("Right")
                    ? config["video-page"]["Right"]
                    : getTranslateText("Right")}
                </p>
                <img
                  style={{ height: "18px", width: "30px" }}
                  src={nearFarArrow}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div ref={warnRef} id="warn-card">
        <Rotate />
        <p className="note">{config["video-page"]["rotateText"]}</p>
      </div>

      <div
        className="stencil"
        ref={stencilImageDiv}
      >
        {Object.keys(regionStencil).map((key) => {
          const Component = regionStencil[key];
          return (
            <div
              key={key}
              id={`stencil-${key}`}
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                opacity: 0,
                visibility: "hidden",
                pointerEvents: "none",
                "--stencil-color": "#fff",
              }}
            >
              <Component
                strokeColor="var(--stencil-color)"
                {...(["Side-Left", "Side-Right"].includes(key) ? { preserveAspectRatio: "xMidYMax meet" } : {})}
              />
            </div>
          );
        })}
      </div>

      <img src={HoldSvg} className="holdImage" ref={holdImage} />
      <div className="displayText" ref={displayText}>
        <p></p>
      </div>
      <div
        style={{ position: "relative", height: "100vh", width: "100vw" }}
        ref={detectionBox}
      ></div>
      {/* ---- partData debug panels (commented out) ----
      <p
        style={{
          position: "absolute",
          top: "30px",
          left: 0,
          backgroundColor: "white",
          padding: "5px",
        }}
        ref={partData}
      ></p>
      <p
        style={{
          position: "absolute",
          top: "50px",
          left: 0,
          backgroundColor: "transparent",
          color: "red",
          padding: "5px",
        }}
        ref={partDataValue}
      ></p>
      <p
        style={{
          position: "absolute",
          top: "150px",
          left: 0,
          backgroundColor: "transparent",
          color: "blue",
          padding: "5px",
        }}
        ref={partDataValueList}
      ></p>
      ---- end partData debug panels ---- */}
      {capturedStencil.length > 0 &&
        capturedStencil.length < 8 &&
        chooseRegionStencil.current.style.display === "none" &&
        holdSkip && (
          <button
            style={{ backgroundColor: config["colors"]["btn"] }}
            className="skip-btn"
            onClick={() => {
              confirmSkipDiv.current.style.display = "flex";
            }}
          >
            <span className="skip-text">
              {Object.keys(config["video-page"]).includes("Skip this region")
                ? config["video-page"]["Skip this region"]
                : getTranslateText("Skip this region")}
            </span>
            <span className="skip-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M6 6 L12 12 L6 18"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6 L18 12 L12 18"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <rect x="19" y="5" width="2" height="14" rx="1" fill="white" />
              </svg>
            </span>
          </button>
        )}
      <img ref={leftNearArrow} className="leftNearArrow" src={nearFarArrow} />
      <img ref={rightNearArrow} className="rightNearArrow" src={nearFarArrow} />
      <img ref={leftFarArrow} className="leftFarArrow" src={nearFarArrow} />
      <img ref={rightFarArrow} className="rightFarArrow" src={nearFarArrow} />
      <img
        ref={leftArrowVin}
        style={{
          height: "20%",
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "rotate(-180deg) translate(50%, 50%)",
          display: "none",
        }}
        src={nearFarArrow}
      />
      <img
        ref={rightArrowVin}
        style={{
          height: "20%",
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "translate(-50%, -50%)",
          display: "none",
        }}
        src={nearFarArrow}
      />
      <img
        ref={upArrow}
        style={{
          height: "20%",
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "rotate(-90deg) translate(20%, -120%)",
          display: "flex",
        }}
        src={nearFarArrow}
      />
      <img
        ref={downArrow}
        style={{
          height: "20%",
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "rotate(-270deg)translate(-20%, -120%)",
          display: "flex",
        }}
        src={nearFarArrow}
      />

      <div ref={confirmSkipDiv} className="skipDiv">
        <h3>
          {Object.keys(config["video-page"]).includes(
            "Are you sure you want to skip this section?",
          )
            ? config["video-page"][
            "Are you sure you want to skip this section?"
            ]
            : getTranslateText("Are you sure you want to skip this section?")}
        </h3>
        <div className="skipDivButtons">
          <div
            onClick={() => {
              skipButton();
              confirmSkipDiv.current.style.display = "none";
            }}
          >
            {Object.keys(config["video-page"]).includes("Yes")
              ? config["video-page"]["Yes"]
              : getTranslateText("Yes")}
          </div>
          <div
            onClick={() => {
              confirmSkipDiv.current.style.display = "none";
            }}
          >
            {Object.keys(config["video-page"]).includes("No")
              ? config["video-page"]["No"]
              : getTranslateText("No")}
          </div>
        </div>
      </div>
      <div ref={skipDiv} className="skipDiv">
        {lumacheck ? (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Low light detected. Please start a new inspection, or choose to 'Retry' or 'Skip' this region.",
            )
              ? config["video-page"][
              "Low light detected. Please start a new inspection, or choose to 'Retry' or 'Skip' this region."
              ]
              : getTranslateText(
                "Low light detected. Please start a new inspection, or choose to 'Retry' or 'Skip' this region.",
              )}
          </h3>
        ) : (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Unable to fit stencil. You can choose to 'Retry' or 'Skip' this region.",
            )
              ? config["video-page"][
              "Unable to fit stencil. You can choose to 'Retry' or 'Skip' this region."
              ]
              : getTranslateText(
                "Unable to fit stencil. You can choose to 'Retry' or 'Skip' this region.",
              )}
          </h3>
        )}
        <div className="skipDivButtons">
          <div
            onClick={() => {
              continueButton();
            }}
          >
            {Object.keys(config["video-page"]).includes("Retry")
              ? config["video-page"]["Retry"]
              : getTranslateText("Retry")}
          </div>
          <div
            onClick={() => {
              skipButton();
            }}
          >
            {Object.keys(config["video-page"]).includes("Skip")
              ? config["video-page"]["Skip"]
              : getTranslateText("Skip")}
          </div>
        </div>
      </div>

      <div
        ref={skipDivFallback}
        className="skipDiv"
        style={{
          width: "90dvw",
          maxWidth: "450px", // Limits width on larger screens
          height: "auto",
          minHeight: "200px",
          zIndex: 10,
          backgroundColor: "#ffffff",
          borderRadius: "20px",
          padding: "30px 24px",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25)",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        <h3
          style={{
            fontSize: "1.1rem",
            color: "#2c3e50",
            lineHeight: "1.6",
            margin: "0 0 24px 0",
            fontWeight: "500",
          }}
        >
          {errorType
            ? config["video-page"][
            "It seems that video app is not compatible with your device. Do you want to switch to image app?"
            ] ||
            getTranslateText(
              "It seems that video app is not compatible with your device. Do you want to switch to image app?",
            )
            : config["video-page"][
            "Are you facing any issues with recording the video. Do you want to switch to image app?"
            ] ||
            getTranslateText(
              "Are you facing any issues with recording the video. Do you want to switch to image app?",
            )}
        </h3>

        <div
          className="skipDivButtons"
          style={{
            display: "flex",
            gap: "12px",
            width: "100%",
            marginTop: "auto",
          }}
        >
          {/* Continue Button - Secondary Action */}
          <div
            onClick={() => {
              patLogs("User chose to continue with video module", inspectionId);
              skipDiv.current.style.display = "none";
              checkForRedirect();
            }}
            style={{
              flex: 1,
              padding: "14px 0",
              borderRadius: "12px",
              backgroundColor: "white",
              color: config["colors"]["secoundaryBtn"]
                ? config["colors"]["secoundaryBtn"]
                : "black",
              border: config["colors"]["secoundaryBtn"]
                ? `2px solid ${config["colors"]["secoundaryBtn"]}`
                : "2px solid black",
              fontSize: "1rem",
              fontWeight: "600",
              cursor: "pointer",
              textAlign: "center",
              transition: "background 0.2s ease",
            }}
          >
            {config["video-page"]["Continue"] || getTranslateText("Continue")}
          </div>

          {/* Switch Button - Primary Action */}
          <div
            onClick={async () => {
              patLogs("User chose to switch to image module", inspectionId);
              // camera closing -> stop recording and upload the video
              stopCarVideoRecordingAndUpload();
              active = false;
              window.stream = null;
              track.stop();
              clearInterval(startTimer);
              await setMandatoryCondition();
              filterPortoModuleList(IMG360CONFIG)
              setScreen("block");
              setCurrentBlock(IMG360CONFIG);
              if (skipDiv.current) skipDiv.current.style.display = "none";
            }}
            style={{
              flex: 1,
              padding: "14px 0",
              borderRadius: "12px",
              backgroundColor: config["colors"]["btn"],
              color: "white",
              fontSize: "1rem",
              fontWeight: "600",
              cursor: "pointer",
              textAlign: "center",
              transition: "background 0.2s ease",
            }}
          >
            {config["video-page"]["Switch"] || getTranslateText("Switch")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StencilVideo;
